import { Route } from '@angular/router';
import { PlayerReportingComponent } from '../../../../pages/statistics/network/player/player-reporting.component';
import { LocationComponent } from '../../../../pages/statistics/network/location/location.component';
import { AirtimeComponent } from '../../../../pages/statistics/network/airtime/airtime.component';
import { RoutingID } from '../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { publisherShareOfVoice } from './publisher-share-of-voice';

export const network: Route = {
  path: 'network-reporting',
  // component: StatisticOverviewComponent,
  title: 'nav.reporting.network',
  data: {
    breadcrumb: 'nav.reporting.network',
    icon: SbIcons.network,
    id: RoutingID.networkReporting,
  },
  children: [
    {
      path: 'player-reporting',
      component: PlayerReportingComponent,
      data: {
        breadcrumb: '',
        id: RoutingID.playerReporting,
      },
    },
    {
      path: 'location-reporting',
      component: LocationComponent,
      data: {
        breadcrumb: '',
        id: RoutingID.locationReporting,
      },
    },
    {
      path: 'airtime-reporting',
      component: AirtimeComponent,
      data: {
        breadcrumb: '',
        id: RoutingID.airtimeReporting,
      },
    },
    publisherShareOfVoice,
    { path: '', redirectTo: RoutingID.playerReporting, pathMatch: 'full' },
  ],
};
